module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 53);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var _assets_js_utils_use_pwa_signature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15);
/* harmony import */ var _assets_js_utils_log_tracking_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
/**
 * @author kyol
 * @description： 代码设计，手写响应式猜源码
 */


global.auxiliaryVars = global.auxiliaryVars || {
  onloaded: false,
  watchProperties: {}
};
// eslint-disable-next-line no-multi-assign
const {
  auxiliaryVars
} = global;
const awaitListName = String.fromCharCode.apply(null, [81, 117, 101, 117, 101]);
const preFix = String.fromCharCode.apply(null, [117, 115, 101]);
const [preFc, Pipe, append] = ["com", "Pipe", "pose"];
// this is use auxiliary tools
class ObserverData {
  constructor(value) {
    this.value = value;
  }
  toString() {
    return this.value;
  }

  // eslint-disable-next-line class-methods-use-this
  toOrigin() {
    return auxiliaryVars.watchProperties;
  }

  // eslint-disable-next-line class-methods-use-this
  [Symbol.toStringTag]() {
    return "ObserverEffect";
  }
}
const useCacheHooks = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "localStorage";
  return (key, hook) => {
    let value = "";
    const saveType = window[type];
    if (Reflect.has(saveType, key)) {
      value = JSON.parse(saveType.getItem(key));
    } else {
      value = typeof hook !== "function" ? hook : hook();
      saveType.setItem(key, JSON.stringify(value));
    }
    return new Proxy(new ObserverData(value), {
      get(origin, keyName) {
        return Reflect.get(origin, keyName);
      },
      set(origin, keyName, val) {
        if (val === null) {
          saveType.removeItem(key);
        } else {
          saveType.setItem(key, JSON.stringify(val));
        }
        return Reflect.set(origin, keyName, val);
      }
    });
  };
};

/**
 *
 * @param {String} keyName
 * @param {any} definePayload
 * @param {Boolean} isRef  : 是不是ref对象，真是ref,false 为reactive
 * @returns ProxyObserver
 */

const useEffect = function () {
  let isRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (keyName, definePayload) {
    let {
      reset = false,
      ref
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // 构造器
    const seDefval = typeof definePayload === "function" ? definePayload() : definePayload;
    if (!auxiliaryVars.watchProperties[keyName]) {
      auxiliaryVars.watchProperties[keyName] = ref ? ref(seDefval) : new ObserverData(seDefval);
    }
    if (reset) auxiliaryVars.watchProperties[keyName].value = seDefval;
    // 拦截器
    return new Proxy(auxiliaryVars.watchProperties[keyName], {
      get(origin, key) {
        let value = Reflect.get(origin, key);
        if (typeof Reflect.get(origin, "value") === "object" && !isRef) value = Reflect.get(origin.value, key);
        return value;
      },
      set(origin, key, value) {
        return Reflect.set(origin, key, value);
      }
    });
  };
};
const defineFunction = Function || (() => {});
const defineObject = Object || {};
const mapFuncNames = ["forEach", "map", "some", "every", "filter"];
// 扩展USEhooks
const useObjects = mapFuncNames.reduce((p, funcName) => {
  p[funcName] = (object, currayFactory) => originKeys(object)[funcName](hightFn(currayFactory, object));
  return p;
}, {});
useObjects.find = (object, currayFactory) => {
  const amiKey = originKeys(object).find(hightFn(currayFactory, object));
  return amiKey ? {
    key: amiKey,
    value: object[amiKey]
  } : undefined;
};
useObjects.filter = (object, currayFactory) => {
  const amiKeyList = originKeys(object).filter(hightFn(currayFactory, object));
  return amiKeyList.reduce((p, key) => Object.assign(p, {
    [key]: object[key]
  }), {});
};
const originKeys = defineObject.keys.bind(defineObject);
const hightFn = (transformTask, origin) => key => transformTask(origin[key], key, origin);
const useHooks = {
  [`${preFix}Local`]: useCacheHooks(),
  [`${preFix}Session`]: useCacheHooks("sessionStorage"),
  [`${preFix}Ref`]: useEffect(),
  [`${preFix}Reactive`]: useEffect(false),
  [`${preFix}Watch`]: function (watchTask) {
    let watchProNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const keys = typeof watchProNames === "string" ? [watchProNames] : watchProNames;
    const symbolName = Symbol(keys);
    auxiliaryVars.watchEffects[symbolName] = watchTask;
    return symbolName;
  },
  delRef: keyName => {
    return Reflect.defineProperty(auxiliaryVars.watchProperties, keyName);
  },
  isRef: instance => defineObject.prototype.toString().call(instance).slice(8, -1) === "ObserverData",
  [`${preFc}${append}`]: function () {
    for (var _len = arguments.length, warrior = new Array(_len), _key = 0; _key < _len; _key++) {
      warrior[_key] = arguments[_key];
    }
    return function () {
      const unFunc = warrior.findIndex(f => typeof f !== "function");
      // eslint-disable-next-line no-bitwise
      if (~unFunc) return new Error(`${unFunc}坐标参数必须是函数,${warrior[unFunc]}`);
      for (var _len2 = arguments.length, intor = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        intor[_key2] = arguments[_key2];
      }
      return warrior.reduceRight((h, f, i) => warrior.length === i + 1 ? f(...h) : f(h), intor);
    };
  },
  [`${preFix}Memo`]: (cacheValue, cacheReslut) => function (nextValue, task) {
    const curResult = typeof nextValue === "function" ? nextValue() : nextValue;
    if (curResult === cacheValue) return cacheReslut;
    cacheValue = curResult;
    for (var _len3 = arguments.length, list = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      list[_key3 - 2] = arguments[_key3];
    }
    cacheReslut = task(...list);
    return cacheReslut;
  },
  syncToggle: function (data, key, value) {
    let time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 300;
    return new Promise(resolve => {
      const oval = data[key];
      data[key] = value;
      setTimeout(() => {
        data[key] = oval;
        resolve();
      }, time);
    });
  },
  [`${preFix}Toggle`]: function (listValue) {
    let pre = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : listValue[0];
    if (listValue[0] === Boolean) listValue = [true, false];
    let index = listValue.findIndex(v => (typeof pre === "function" ? pre(v) : v) === pre);
    const {
      length
    } = listValue;
    // eslint-disable-next-line no-bitwise
    if (index === length - 1) index = -1;
    pre = listValue[index + 1];
    return listValue[index + 1];
  },
  curryDalay(taskFn) {
    let timer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
    let callback = arguments.length > 2 ? arguments[2] : undefined;
    return function () {
      for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        params[_key4] = arguments[_key4];
      }
      if (taskFn.$beDaley) clearTimeout(taskFn.$beDaley);
      return new Promise(resolve => {
        taskFn.$beDaley = setTimeout(_ => {
          var _taskFn$call;
          callback === null || callback === void 0 ? void 0 : callback(taskFn.call(this, ...params));
          resolve(taskFn === null || taskFn === void 0 ? void 0 : (_taskFn$call = taskFn.call) === null || _taskFn$call === void 0 ? void 0 : _taskFn$call.call(taskFn, this, ...params));
          taskFn.$beDaley = undefined;
        }, timer);
      });
    };
  },
  [`${preFix}${Pipe}`]: pipeFn => params => Promise[pipeFn(params) ? "resolve" : "reject"](params),
  [`${preFix}${awaitListName}`](list, size, curryFn) {
    let index = -1;
    let isOver = false;
    const stop = () => {
      isOver = true;
    };
    const next = async () => {
      if (isOver) return;
      index++;
      const data = list[index];
      if (data === undefined) {
        isOver = true;
      } else {
        const _index = index;
        await data();
        curryFn({
          index: _index,
          next,
          stop
        });
      }
    };
    const startArr = list.slice(0, size);
    startArr.forEach(next);
  }
};
const $wj_tools = {
  $ENV: function () {
    const payload = {
      userAgent: "",
      /*
       * 所有key名对应的value
       * value：[ [第一个数组是需要存在的匹配关键字],[第二个数组是需要不匹配上的关键字] ]
       */
      isWeixin: [["MicroMessenger"], ["wxwork"]],
      isWxwork: [["MicroMessenger", "wxwork"]],
      isLark: [["Lark"]],
      // 飞书
      isDingTalk: [["DingTalk"]] // 钉钉
    };

    const state = {};
    // 存储信息数据
    return {
      // 设置Ua的来源信息
      setUserAgent(ua) {
        Reflect.set(payload, "userAgent", ua);
      },
      // 扩展列表私有属性 payload 对象
      $extend(name, value) {
        if (typeof name === "object") {
          Object.assign(payload, name);
        } else {
          payload[name] = value;
        }
      },
      // 查看对应的key 或者全部key
      viewList(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (key && payload.hasOwnProperty(key)) return Reflect.get(payload, key);
        return payload;
      },
      /**
       * @description： 返回判断环境
       * @param {String in keyof payload} name
       * @return {Boolean}
       *
       */
      get(name) {
        var _global, _global$window, _global$window$naviga;
        // 缓存已经读取过的数据
        if (Reflect.has(state, name)) return Reflect.get(state, name);
        if (name === "userAgent") return Reflect.get(payload, name);
        const [inc = [], exc = []] = Reflect.get(payload, name) || [];
        const au = payload.userAgent || ((_global = global) === null || _global === void 0 ? void 0 : (_global$window = _global.window) === null || _global$window === void 0 ? void 0 : (_global$window$naviga = _global$window.navigator) === null || _global$window$naviga === void 0 ? void 0 : _global$window$naviga.userAgent) || "";
        const status = inc.every(s => au.includes(s)) && exc.every(s => !au.includes(s));
        Reflect.set(state, name, status);
        return status;
      },
      // 移除数据中心
      remove(key) {
        Reflect.deleteProperty(payload, key);
      },
      // thunk执行者函数
      defineState() {
        let middlewareThunk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => ({});
        let keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "defineState";
        // eslint-disable-next-line no-return-assign
        return this[keyName] = function () {
          return middlewareThunk(...arguments);
        };
      }
    };
  }(),
  // 后续扩展其定义
  defineInit() {},
  /**
   *
   * @param {Object} data , 就是接口对象
   * @description : 获取套餐接口数据，格式化有效数据
   * @returns Object <{
   *               version：: 当前版本
   *               expireTime：有效时间
   *               nextVersion：下一个版本
   *           }>
   * }
   */
  formatUserPackageInfo(data) {
    // 套餐类型
    const versiobnMap = ["free", "advance_version", "enterprise_version", "enterprise_ultimate_version"];
    let [version, expireTime, isTry] = ["free", "", false];
    if (data.package_status) {
      /**
       * advance_version 高级版本
       * enterprise_version 企业版标准版
       * enterprise_ultimate_version'; // 企业旗舰版
       */
      isTry = !!data.package_status.is_trial;
      version = data.package_status.version;
      expireTime = data.package_status.expire_time || "";
    }
    // 免费版本能升级,其他版本只能续费
    const index = versiobnMap.indexOf(version); // 当前版本索引
    const nextVersion = versiobnMap[index === versiobnMap.length - 1 ? versiobnMap.length - 1 : index + 1]; // 下一本版本名称
    return {
      version,
      // 当前版本
      expireTime,
      // 有效时间
      nextVersion,
      // 下一个升级版本  名称
      isTry,
      // 是不是试用版
      isFree: version == "free",
      // 是不是免费版本
      isAdv: version === "advance_version" && !isTry,
      // 是不是高级版
      isEnt: version === "enterprise_version" && !isTry,
      // 是不是企业版
      isUlt: version === "enterprise_ultimate_version" && !isTry,
      // 是不是旗舰版
      freeName: "free",
      advName: "advance_version",
      // 高级版名称
      entName: "enterprise_version",
      ultName: "enterprise_ultimate_version"
    };
  },
  /**
   * 校验格式函数
   */
  checkRules: (() => ({
    // 邮箱校验
    isEmail(value, customExp) {
      const exp = customExp || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return exp === null || exp === void 0 ? void 0 : exp.test(value);
    },
    // 国内座机号
    isLandlinePhone(value, customExp) {
      const exp = customExp || /0\d{2,3}-?\d{7,8}/;
      return exp.test(value);
    },
    // 国内手机号
    isMobile(value) {
      let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
      let customExp = arguments.length > 2 ? arguments[2] : undefined;
      const exp = customExp || new RegExp(`^1[3456789]\\d{${size}}$`);
      return exp.test(value);
    },
    // 纯数字 0 - 9
    isNumber(value) {
      return /^[0-9]+$/.test(value);
    },
    standardTofixed(value) {
      let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      const [int, float] = (String(value) || "").split(".");
      const padEnd = (float || "").slice(0, size).padEnd(size, "0");
      return size === 0 ? int : `${int}.${padEnd}`;
    }
  }))(),
  questionTypeList(expendsData) {
    const types = {
      "2": {
        template: "q-select",
        name: "单选",
        formName: "单选",
        satisName: "单选",
        title: "请选择一个选项",
        option: "选项",
        trackName: "single_select"
      },
      "3": {
        template: "q-select",
        name: "多选",
        formName: "多选",
        satisName: "多选",
        title: "请选择以下选项 (多选)",
        subtitle: "单选题",
        option: "选项",
        trackName: "multiple_select"
      },
      "4": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "请选择以下选项",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "5": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "矩阵单选题",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "6": {
        template: "q-blank",
        name: "填空",
        formName: "填空",
        title: "请填写本项内容",
        trackName: "blank"
      },
      "7": {
        template: "q-matrix-default",
        name: "矩阵打分",
        title: "请给以下各项打分",
        satisTitle: "请问你对以下描述的感觉是",
        option: "打分",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "8": {
        template: "q-blank",
        name: "级联题",
        title: "出生日期",
        trackName: "date"
      },
      "9": {
        template: "q-classification",
        name: "分类",
        title: "请按照分类规则，将左侧选项拖入右侧分组中",
        option: "选项",
        suboption: "类别",
        trackName: "classification"
      },
      "50": {
        template: "q-score",
        name: "打分",
        formName: "打分",
        title: "请给本项打分",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "选项",
        trackName: "score"
      },
      "60": {
        template: "q-default",
        name: "排序",
        formName: "排序",
        title: "请给以下选项排序",
        option: "选项",
        trackName: "sort"
      },
      "70": {
        template: "q-desc",
        name: "段落说明",
        title: "请阅读本项说明，然后回答问题",
        trackName: "remark"
      },
      "95": {
        template: "q-multi-blank",
        name: "多项填空",
        title: "请填写以下内容",
        option: "填空",
        trackName: "multiple_blank"
      },
      "100": {
        template: "q-matrix-default",
        name: "矩阵填空",
        title: "请填写以下内容",
        option: "填空",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "105": {
        template: "q-goods",
        name: "商品",
        formName: "商品",
        title: "请挑选您喜欢的商品",
        subtitle: "商品题",
        option: "选项",
        trackName: "goods"
      },
      collection: {
        template: "q-collection",
        name: "收款题",
        formName: "收款",
        createFn: "createCollection",
        trackName: "collection"
      },
      contact_us: {
        template: "q-contact-us",
        name: "联系我们",
        createFn: "createContactUs",
        trackName: "contact_us"
      },
      enterprise_certification_info: {
        template: "q-enterprise-auth",
        createFn: "createEnterpriseAuth",
        name: "企业认证",
        trackName: "enterprise_certification_info"
      },
      user_info: {
        template: "q-user-info",
        name: "个人信息",
        title: "个人信息录入"
      },
      exam_inform: {
        template: "q-exam-inform",
        name: "考前须知",
        title: "考前须知"
      },
      geographical_multiple_blank: {
        template: "q-geographical",
        name: "地理位置",
        title: "所在位置",
        trackName: "geography"
      },
      rich_text: {
        template: "q-rich",
        name: "图文介绍",
        title: "请阅读本项说明，然后回答问题",
        trackName: "rich"
      },
      occupation: {
        template: "q-select",
        name: "职业",
        title: "您目前的职业是？",
        option: "在校学生",
        suboption: "政府/机关干部/公务员",
        trackName: "occupation"
      },
      singlevote: {
        template: "q-default",
        name: "文字投票",
        title: "请给以下选项投票",
        option: "选项",
        trackName: "font_vote"
      },
      education: {
        template: "q-select",
        name: "学历",
        title: "您的最高学历（含目前在读）是？",
        option: "小学及以下",
        suboption: "初中",
        trackName: "education"
      },
      sex: {
        template: "q-select",
        name: "性别",
        title: "性别",
        option: "男",
        suboption: "女",
        trackName: "sex"
      },
      age: {
        template: "q-select",
        name: "年龄",
        satisName: "年龄段",
        title: "您的年龄是？",
        option: "18岁以下",
        suboption: "18~24岁",
        trackName: "age"
      },
      judge: {
        template: "q-select",
        name: "判断题",
        title: "请判断本项叙述是否正确？",
        option: "是",
        suboption: "否",
        trackName: "single_select"
      },
      multiplevote: {
        template: "q-default",
        name: "文字投票题",
        title: "请给以下选项投票（多选）",
        option: "选项",
        trackName: "font_vote_multiple"
      },
      groupvote_single: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票",
        option: "选项",
        trackName: "groupvote_single"
      },
      groupvote_multiple: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票（多选）",
        option: "选项",
        trackName: "groupvote_multiple"
      },
      videovote_single: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票"
      },
      videovote_multiple: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票（多选）"
      },
      listening_single: {
        template: "q-select",
        name: "听力题",
        title: "点击上传音频/视频文件",
        option: "选项",
        trackName: "listen"
      },
      dropdown: {
        template: "q-default",
        name: "下拉",
        formName: "下拉",
        title: "请选择一个选项",
        option: "选项",
        trackName: "dropdown"
      },
      short_answer: {
        template: "q-blank",
        name: "简答题",
        title: "请简要阐述你的观点",
        trackName: "short_answer"
      },
      name: {
        template: "q-blank",
        name: "姓名",
        title: "姓名",
        trackName: "name"
      },
      mobile: {
        template: "q-blank",
        name: "手机",
        title: "手机",
        trackName: "mobile"
      },
      email: {
        template: "q-blank",
        name: "邮箱",
        title: "邮箱",
        trackName: "email"
      },
      wechat_id: {
        template: "q-blank",
        name: "微信号",
        title: "微信号",
        trackName: "wechat_id"
      },
      id_card: {
        template: "q-blank",
        name: "身份证号",
        title: "身份证号",
        trackName: "id_card"
      },
      employee_id: {
        template: "q-blank",
        name: "工号",
        title: "工号",
        trackName: "employee_id"
      },
      blank_num: {
        template: "q-blank",
        name: "数字填空",
        title: "数字",
        trackName: "blank_num"
      },
      classes: {
        template: "q-blank",
        name: "班级",
        title: "班级",
        trackName: "classes"
      },
      grades: {
        template: "q-blank",
        name: "年级",
        title: "年级",
        trackName: "grades"
      },
      student_id: {
        template: "q-blank",
        name: "学号",
        title: "学号",
        trackName: "student_id"
      },
      company: {
        template: "q-blank",
        name: "公司",
        title: "公司",
        trackName: "company"
      },
      department: {
        template: "q-blank",
        name: "部门",
        title: "部门",
        trackName: "department"
      },
      university_form: {
        template: "q-blank",
        name: "学校",
        title: "学校",
        trackName: "university_form"
      },
      major_form: {
        template: "q-blank",
        name: "专业",
        title: "专业",
        trackName: "major_form"
      },
      phone: {
        template: "q-phone",
        trackName: "mobile"
      },
      multi_line_blank: {
        template: "q-multiline-blank",
        trackName: "multiple_blank"
      },
      auto_table: {
        template: "q-auto-table",
        name: "自增表格",
        title: "请填写你的团队成员信息",
        option: "标题",
        trackName: "auto_table"
      },
      horz_blank: {
        template: "q-horz-blank",
        name: "横向填空",
        title: "请填写以下信息",
        option: '姓名<span class="ipt-wrap"><input type="text" style="width: 64px"></span>年龄<span class="ipt-wrap"><input type="text" style="width: 32px"></span>岁<br>联系方式<span class="ipt-wrap"><input type="text" style="width: 88px"></span>',
        trackName: "horizontal_blank"
      },
      cloze: {
        template: "q-cloze",
        name: "完形填空",
        title: "完形填空",
        trackName: "cloze"
      },
      banked_cloze: {
        template: "q-banked-cloze",
        name: "选词填空",
        title: "选词填空",
        option: "选项",
        suboption: ["请输入标题", "的", "地", "得"],
        trackName: "banked_cloze"
      },
      date: {
        template: "q-blank",
        name: "日期",
        title: "日期",
        trackName: "date"
      },
      upload_file: {
        template: "q-upload-file",
        name: "文件收集",
        title: "请上传文件",
        trackName: "upload"
      },
      image_upload: {
        template: "q-image-upload",
        name: "图片收集",
        assessName: "图片收集",
        title: "请上传图片",
        trackName: "image_upload"
      },
      time: {
        template: "q-time",
        name: "时间",
        title: "时间",
        trackName: "time"
      },
      signature: {
        template: "q-signature",
        name: "电子签名",
        subtitle: "请在此处签名",
        title: "签名",
        trackName: "signature"
      },
      image_single: {
        template: "q-image",
        name: "图片选择",
        formName: "图片单选",
        title: "请选择以下图片",
        option: "图片",
        trackName: "image_select"
      },
      image_multiple: {
        template: "q-image",
        name: "图片多选",
        title: "请选择以下图片（多选）",
        option: "图片",
        trackName: "image_multiple"
      },
      imagevote_single: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票",
        option: "图片",
        trackName: "image_vote"
      },
      imagevote_multiple: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票（多选）",
        option: "图片",
        trackName: "image_vote"
      },
      nps_score: {
        template: "q-nps-score",
        name: "NPS",
        formName: "NPS",
        title: "您向朋友或同事推荐我们的可能性有多大？",
        trackName: "nps"
      },
      scale: {
        template: "q-scale",
        name: "量表",
        title: "请您对此项目进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        option: "标题",
        trackName: "scale"
      },
      matrix_scale: {
        template: "q-matrix-scale",
        name: "矩阵量表",
        title: "请您对以下各行内容进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "标题",
        trackName: "matrix_scale"
      },
      city: {
        template: "q-city",
        trackName: "address"
      },
      address: {
        template: "q-address",
        name: "城市/地址",
        formName: "城市/地址",
        satisName: "城市",
        title: "地址",
        trackName: "address"
      },
      major: {
        template: "q-cascader",
        name: "专业",
        trackName: "major"
      },
      industry: {
        template: "q-cascader",
        name: "行业",
        trackName: "industry"
      },
      cascader: {
        template: "q-cascader",
        name: "多级下拉",
        formName: "多级下拉",
        title: "请选择以下选项",
        trackName: "cascader"
      },
      university: {
        template: "q-cascader",
        name: "院校",
        trackName: "university"
      },
      proportion: {
        template: "q-proportion",
        name: "比重",
        formName: "比重",
        title: "请选择以下各项所占的百分比",
        option: "选项",
        trackName: "proportion"
      },
      evaluation: {
        template: "q-evaluation",
        name: "评价",
        formName: "评价",
        title: "请您对我们的服务进行评价",
        subtitle: "单选题",
        option: "选项",
        trackName: "evaluation"
      },
      split_line: {
        template: "q-split-line",
        name: "分割线",
        trackName: "split_line"
      },
      countdown: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      countdown_show_only: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      score_single: {
        template: "q-select",
        title: "请问你对以下描述的感觉是",
        name: "评分单选",
        trackName: "pc_q_grade_single"
      },
      work_age: {
        template: "q-select",
        title: "您的工作年限是？",
        name: "工龄",
        trackName: "pc_q_seniority"
      },
      base_info: {
        template: "q-multi-blank",
        title: "请填写您的基本信息",
        name: "基本信息",
        trackName: "pc_q_basic"
      },
      navigation: {
        template: "q-navigation",
        name: "地图导航",
        trackName: "navigation",
        title: "导航到这里"
      },
      page: {
        template: "q-page",
        name: "分页",
        trackName: "page"
      },
      multiple_dropdown: {
        template: "q-default",
        name: "下拉",
        title: "请选择以下选项 (多选)",
        option: "选项",
        trackName: "dropdown"
      },
      delivery_address: {
        template: "q-delivery-address",
        name: "收货信息",
        title: "请输入收货信息",
        trackName: "delivery_address"
      },
      ...expendsData
    };
    return {
      typeList: Object.keys(types),
      typesData: types,
      // 正向操作
      has() {
        for (var _len5 = arguments.length, keys = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          keys[_key5] = arguments[_key5];
        }
        return keys.every(item => this.typeList.includes(item));
      },
      // 反向操作
      revHas(name) {
        let prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "name";
        let typeKey = "undefined";
        this.typeList.find(
        // eslint-disable-next-line no-return-assign
        key => {
          var _types$key;
          return (types === null || types === void 0 ? void 0 : (_types$key = types[key]) === null || _types$key === void 0 ? void 0 : _types$key[prop]) === name && (typeKey = key);
        });
        return typeKey;
      }
    };
  },
  //  新增接口参数
  appendLoginParams(params) {
    var _this$$route;
    const {
      page_id,
      invite_id,
      reg_from_source,
      reg_fromm_id
    } = (this === null || this === void 0 ? void 0 : (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : _this$$route.query) || {};
    const obj = {
      page_id,
      invite_id,
      reg_from_source,
      reg_fromm_id
    };
    Object.keys(obj).forEach(key => {
      if (obj[key] == 0 || !!obj[key]) params[key] = obj[key];
    });
  },
  usePWASignature: _assets_js_utils_use_pwa_signature_js__WEBPACK_IMPORTED_MODULE_0__,
  logTracker: _assets_js_utils_log_tracking_index_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  defineFunction,
  defineObject,
  useHooks,
  useObjects,
  hooks: {
    install(Vm) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      /**
       * @author: wei
       * @date 24.01.08
       * @description 项目中必使用的扩展函数
       */
      const [FactoryVue, getCurrentInstanceFc] = [Vm, options === null || options === void 0 ? void 0 : options.getCurrentInstance];
      Object.assign(FactoryVue, {
        [`${preFix}Instance`]: () => getCurrentInstanceFc().proxy,
        [`${preFix}Router`]: () => getCurrentInstanceFc().proxy.$router,
        [`${preFix}Route`]: () => getCurrentInstanceFc().proxy.$route,
        [`${preFix}State`]: () => {
          var _getCurrentInstanceFc;
          return (_getCurrentInstanceFc = getCurrentInstanceFc().proxy.$store) === null || _getCurrentInstanceFc === void 0 ? void 0 : _getCurrentInstanceFc.state;
        },
        [`${preFix}Refs`]: () => getCurrentInstanceFc().proxy.$refs,
        [`${preFix}Options`]: options => Object.assign(getCurrentInstanceFc().proxy.$options, options),
        [`${preFix}ReplaceRoute`]() {
          const formatUrl = function () {
            let {
              path = "",
              query = {}
            } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return `${path}${path.includes("?") ? "&" : Object.keys(query).length ? "?" : ""}${Object.keys(query).reduce((p, n, i) => `${p}${i ? "&" : ""}${n}=${query[n]}`, "")}`;
          };
          const setRoute = params => Promise.resolve(history.replaceState(null, null, formatUrl(params)));
          try {
            const {
              useRouter
            } = Vm;
            const Router = useRouter();
            return params => {
              const {
                currentRoute: {
                  path: currentRoutePath = "/"
                }
              } = Router;
              const {
                path
              } = params;
              return path === currentRoutePath ? Router.replace(params).catch(e => {}) : setRoute(params);
            };
          } catch (e) {
            return setRoute;
          }
        },
        ...useHooks
      });
    },
    ...useHooks,
    ...useObjects
  }
};
// if (typeof exports !== "undefined") {
//     export default $wj_tools;
// }
// if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
//     module.exports = $wj_tools;
// }

/* harmony default export */ __webpack_exports__["default"] = ($wj_tools);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(18)))

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/message.css");

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dropdown-item.css");

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dropdown-menu.css");

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dropdown.css");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/message-box");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dialog.css");

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/input-number.css");

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCreateProjectUrl", function() { return isCreateProjectUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isUsedPWASignature", function() { return isUsedPWASignature; });
/* harmony import */ var _tools_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/**
 * @description: 项目在 pwa 中访问时，创建项目的接口应带有 pwa 标记，方便后端统计项目创建方式
 */



// 创建项目相关接口
const createProjectUrl = ["/edit/ajax/survey_copy/",
// 复制模板
"/edit/api/create/",
// 空白创建
"/edit/api/copy/",
// 复制已有项目
"/edit/api/textproject/",
// 文本创建
"/edit/api/ref/" // 引用收藏的模板创建
];

// 判断 url 是否为创建项目接口
function isCreateProjectUrl(url) {
  return createProjectUrl.some(item => url.includes(item));
}

// 判断是否使用 pwa 的签名
function isUsedPWASignature(url) {
  const {
    isPWA
  } = Object(_tools_js__WEBPACK_IMPORTED_MODULE_0__[/* distinguishUserAgentUtils */ "b"])();
  if (isPWA && isCreateProjectUrl(url)) {
    return true;
  }
  return false;
}

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/assets/js/utils/cookie.js
var cookie = __webpack_require__(5);

// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/base.js

class base_LogBase {
  constructor(source, url) {
    this.source = source;
    this.url = url;
  }
  static createHttpRequest() {
    if (window.ActiveXObject) {
      return new window.ActiveXObject("Microsoft.XMLHTTP");
    }
    if (window.XMLHttpRequest) {
      return new XMLHttpRequest();
    }
  }
  static formatLogData(data) {
    const result = {};
    Object.keys(data).forEach(key => {
      let value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
      if (value !== null && typeof value !== "undefined") {
        value = value.toString();
      }
      result[key] = value;
    });
    return result;
  }

  // eslint-disable-next-line class-methods-use-this
  getExtraData() {
    const extraInfo = ["hawkeye_mid", "browser_id"]; // 默认必传的值
    const cookieData = {};
    extraInfo.forEach(key => {
      cookieData[key] = Object(cookie["b" /* get */])(key);
    });
    const browserData = {
      su: document.referrer
    };
    return Object.assign(cookieData, browserData, {
      pageurl: window.location.href
    });
  }
}
// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/ali-log-tracking.js

class ali_log_tracking_AliLog extends base_LogBase {
  constructor(module) {
    const host = "cn-shanghai.log.aliyuncs.com";
    const project = "wj-applog-prod-10001-sls";
    const logstore = "wj-fed-user-operationlog";
    const url = `//${project}.${host}/logstores/${logstore}/track?APIVersion=0.6.0`;
    super(module, url);
  }
  push(topic, logData) {
    const postData = this.getPostData(topic, logData);
    const request = base_LogBase.createHttpRequest();
    try {
      request.open("POST", this.url, true);
      request.setRequestHeader("x-log-bodyrawsize", 0);
      request.send(JSON.stringify(postData));
    } catch (e) {
      var _window;
      if ((_window = window) !== null && _window !== void 0 && _window.console && typeof window.console.log === "function") {
        console.log(`Failed to log to ali log service because of this exception:\n${e}`);
        console.log("Failed log data:", this.url);
      }
    }
  }
  getExtraData() {
    const extraInfo = super.getExtraData();
    return {
      ...extraInfo
    };
  }
  getPostData(topic, logData) {
    const data = Object.assign(logData, this.getExtraData());
    const logContents = base_LogBase.formatLogData(data);
    return {
      __topic__: topic,
      __source__: this.module,
      __logs__: [logContents]
    };
  }
}
// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/tencent-log-tracking.js

class tencent_log_tracking_TencentLog extends base_LogBase {
  constructor(module) {
    const url = "https://ap-shanghai.cls.tencentcs.com/tracklog?topic_id=89daeb82-6d65-41e9-8a95-f70c8d52ed52";
    super(module, url);
  }
  push(topic, logData) {
    const postData = this.getPostData(topic, logData);
    const request = base_LogBase.createHttpRequest();
    try {
      request.open("POST", this.url, true);
      request.setRequestHeader("Content-type", "application/json");
      request.send(JSON.stringify(postData));
    } catch (e) {
      var _window;
      if ((_window = window) !== null && _window !== void 0 && _window.console && typeof window.console.log === "function") {
        console.log(`Failed to log to tencent log service because of this exception:\n${e}`);
        console.log("Failed log data:", this.url);
      }
    }
  }
  getPostData(topic, logData) {
    var _window2, _window2$location;
    const data = Object.assign(logData, this.getExtraData());
    const logContents = base_LogBase.formatLogData(data);
    return {
      logs: [{
        contents: {
          topic,
          module: this.module,
          ...logContents
        },
        time: new Date().getTime() // TODO: 是否可以不传
      }],

      source: ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.href) || "unknown"
    };
  }
}
// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/index.js


/* harmony default export */ var log_tracking = __webpack_exports__["a"] = ({
  AliLog: ali_log_tracking_AliLog,
  TencentLog: tencent_log_tracking_TencentLog
});

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/message");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/tooltip");

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dropdown-item");

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dropdown-menu");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/button");

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dropdown");

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/message-box.css");

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQueryString; });
/* unused harmony export hideMobile */
/* unused harmony export isNotEmpty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return distinguishUserAgentUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return loadJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return urlDelP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataURLtoFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadGenerateQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserAgentInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isWxMiniApp; });
/* unused harmony export insertHTML */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleAppClintPostMes; });
// 获取url链接中的参数
function getQueryString(name) {
  let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
  const r = source.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 手机打*号
function hideMobile(mobile) {
  if (!mobile) return "";
  return `${mobile.substr(0, 3)}****${mobile.substr(-4)}`;
}

// 判断变量是否为空
function isNotEmpty(obj) {
  if (typeof obj === "undefined" || obj == null) {
    return false;
  }
  if (typeof obj === "function") {
    return true;
  }
  if (obj.constructor == Number) {
    if (obj) {
      return true;
    }
    return false;
  }
  if (typeof obj === "string") {
    if (obj !== "") {
      return true;
    }
    return false;
  }
  return Object.keys(obj).length > 0;
}

// 区分浏览器类型
function distinguishUserAgentUtils(userAgent) {
  if (typeof window !== "undefined") {
    var _window, _window$navigator, _window2;
    const ua = userAgent || ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent.toLowerCase());
    const isTouTiaoMiniApp = ua.includes("toutiaomicroapp");
    const isQQMiniApp = ua.includes("qq") && ua.includes("miniprogram") && !ua.includes("micromessenger");
    const isBaiduMiniApp = ua.includes("baiduboxapp") && ua.includes("swan");
    const isWeixinMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    return {
      isEdge: ua.includes("Edge"),
      isFF: ua.includes("Firefox"),
      isOpera: ua.includes("Opera"),
      isBB: ua.includes("BlackBerry"),
      isChrome: ua.includes("Chrome"),
      isMaxthon: ua.includes("Maxthon"),
      isFeishu: ua.includes("Lark/"),
      isIos: /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isSafari: ua.includes("Safari") && !ua.includes("Chrome"),
      isIE: !!window.ActiveXObject || "ActiveXObject" in window,
      isMobile: /(iPad|iPhone|iPod|Opera Mini|Android.*Mobile|NetFront|PSP|BlackBerry|Windows Phone)/gi.test(ua),
      isWeixin: ua.match(/MicroMessenger/i) === "micromessenger",
      isWeibo: ua.match(/WeiBo/i) === "weibo",
      isWxwork: ua.match(/wxwork/i) === "wxwork",
      isQQ: ua.match(/QQ/i) === "qq",
      isIosApp: ua.includes("wenjuan/") && /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isApp: ua.includes("wenjuan/") || ua.includes("android_app/"),
      isTeacherApp: ua.includes("campusteacher/") || ua.includes("campusstudent/"),
      isHarmony: ua.includes("harmony_wenjuanwrap"),
      isAndroidApp: ua.includes("android_app/"),
      isAndroid: (ua.match(/android/i) === "android" || ua.match(/adr/i) === "adr") && ua !== "android_app/1.0.0",
      // ios android 客户端
      isNative: ua.match(/android_app\//i) === "android_app/" || ua.match(/wenjuan\//i) === "wenjuan/",
      isBaiying: ua.includes("baiying"),
      isDingding: ua.includes("DingTalk"),
      isTencentWemeet: ua.includes("tencent_wemeet"),
      isMac: /macintosh|mac os x/i.test(ua),
      isPWA: (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.matchMedia("(display-mode: minimal-ui)").matches,
      isUc: ua.includes("ucbrowser"),
      isCloudpay: ua.includes("unionpay"),
      isDingTalk: ua.includes("dingtalk"),
      isTencentMeeting: ua.includes("tencent_wemeet"),
      isQuark: ua.includes("quark"),
      isTouTiaoMiniApp,
      isQQMiniApp,
      isBaiduMiniApp,
      isWeixinMiniApp,
      isMiniApp: isTouTiaoMiniApp || isQQMiniApp || isBaiduMiniApp || isWeixinMiniApp,
      isHarmonyApp: ua.includes("harmonyos") && ua.includes("wenjuan/") && !ua.includes("android_app/")
    };
  }
  return {};
}

// js中动态加载script，并在load后触发cb
function loadJS(url, callback) {
  const script = document.createElement("script");
  const fn = callback || function () {};
  script.type = "text/javascript";
  // IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    // 其他浏览器
    script.onload = function () {
      fn();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

// 删除URL上某个参数
function urlDelP(url, name) {
  const urlArr = url.split("?");
  if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
    const query = urlArr[1];
    const obj = {};
    const arr = query.split("&");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    const querys = JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    let searchs = "";
    if (querys) {
      searchs = `?${querys}`;
    }
    const urlte = urlArr[0] + searchs;
    return urlte;
  }
  return url;
}
/**
 * 将base64转换为文件
 * @param {String} dataUrl 图片地址
 * @param {String} imgType 图片类型 传png,jpg等 而不是image/png
 * @return blob文件
 */
function dataURLtoFile(dataUrl, imgType) {
  var _arr$;
  // 替换base64图片的图片类型
  if (imgType) {
    const types = dataUrl.match(/data:image[^;]*;base64,/gi);
    types.forEach(type => {
      dataUrl = dataUrl.replace(new RegExp(`${type}`, "g"), `data:image/${imgType};base64,`);
    });
  }
  const arr = dataUrl.split(",");
  const reg = (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : _arr$.match(/:(.*?);/);
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: reg ? reg[1] : ""
  });
}

// 前端生成二维码-下载二维码
function downloadGenerateQRCode(url) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "图片";
  if (window.navigator.msSaveOrOpenBlob) {
    // ie
    const bstr = atob(url.split(",")[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr]);
    window.navigator.msSaveOrOpenBlob(blob, `${name}.png`);
  } else {
    // 非ie
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", `${name}.png`);
    a.click();
  }
}
function getUserAgentInfo() {
  const {
    userAgent
  } = navigator;
  let version;
  if (/opera/i.test(userAgent) || /OPR/i.test(userAgent)) {
    version = getVersion(userAgent, "OPR/(\\d+\\.+\\d+)");
    return ["Opera", version];
  }
  if (/compatible/i.test(userAgent) && /MSIE/i.test(userAgent)) {
    version = getVersion(userAgent, "MSIE (\\d+\\.+\\d+)");
    return ["IE", version];
  }
  if (/Edg/i.test(userAgent)) {
    version = getVersion(userAgent, "Edg/(\\d+\\.+\\d+)");
    return ["Edge", version];
  }
  if (/Firefox/i.test(userAgent)) {
    version = getVersion(userAgent, "Firefox/(\\d+\\.+\\d+)");
    return ["Firefox", version];
  }
  if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
    version = getVersion(userAgent, "Version/(\\d+\\.+\\d+)");
    return ["Safari", version];
  }
  if (/Chrome/i.test(userAgent) && /Safari/i.test(userAgent)) {
    version = getVersion(userAgent, "Chrome/(\\d+\\.+\\d+)");
    return ["Chrome", version];
  }
  if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
    return ["IE", "any"];
  }
}
function getVersion(userAgent, reg) {
  const reBrowser = new RegExp(reg);
  reBrowser.test(userAgent);
  return parseInt(RegExp.$1);
}

// 判断是否是小程序环境
function isWxMiniApp() {
  try {
    var _window3, _window3$navigator, _window3$navigator$us;
    const ua = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$navigator = _window3.navigator) === null || _window3$navigator === void 0 ? void 0 : (_window3$navigator$us = _window3$navigator.userAgent) === null || _window3$navigator$us === void 0 ? void 0 : _window3$navigator$us.toLowerCase();
    const uaIsWxMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    if (uaIsWxMiniApp) return true;
    const appname = getQueryString("appname");
    if (appname === "wj-miniapp") return true;
    if (window.__wxjs_environment === "miniprogram") return true;
  } catch (error) {}
}

// insert HTML
function insertHTML(html, editor) {
  if (window.getSelection) {
    // IE9 and non-IE
    const sel = window.getSelection();
    if (editor && sel.focusNode !== editor && sel.focusNode.parentNode !== editor) {
      editor.innerHTML += html;
      return;
    }
    if (sel.getRangeAt && sel.rangeCount) {
      let range = sel.getRangeAt(0);
      range.deleteContents();
      const el = document.createElement("div");
      el.innerHTML = html;
      const frag = document.createDocumentFragment();
      let node = el.firstChild;
      let lastNode;
      while (node) {
        lastNode = frag.appendChild(node);
        node = el.firstChild;
      }
      range.insertNode(frag);

      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type !== "Control") {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
}

// app端交互
function handleAppClintPostMes() {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    isIosApp,
    isAndroidApp,
    isHarmonyApp
  } = distinguishUserAgentUtils(navigator.userAgent);
  if (isHarmonyApp) {
    window.ohosCallNative && window.ohosCallNative.postMessage({
      type,
      data
    });
  } else if (isIosApp) {
    var _window$webkit;
    if ((_window$webkit = window.webkit) !== null && _window$webkit !== void 0 && _window$webkit.messageHandlers) {
      window.webkit.messageHandlers.app_nativeInteraction.postMessage({
        type,
        data
      });
    }
  } else if (isAndroidApp && window.android) {
    window.android.postMessage(JSON.stringify({
      type,
      data
    }));
  }
}

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/tooltip.css");

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = require("dayjs");

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/input-number");

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return del; });
/* unused harmony export getParseDomain */
// 操作cookie
function set(c_name, value, expiredays, beforeDomain) {
  let exdate;
  const domain = getParseDomain(beforeDomain);
  // expiredays 可以是Number类型的过期天数
  // 也可以是String类型的日期字符串
  // 还可以是Date类型的
  if (expiredays && expiredays instanceof Date) {
    // expiredays是Date类型
    exdate = expiredays;
  } else if (expiredays && isDate(expiredays)) {
    // expiredays是日期字符串
    exdate = new Date(expiredays).toUTCString();
  } else {
    // expiredays为Nubmer类型或者未设置
    const newDate = new Date();
    expiredays = !expiredays || expiredays != Number(expiredays) ? 1 : expiredays;
    newDate.setDate(newDate.getDate() + expiredays);
    exdate = newDate.toUTCString();
  }
  document.cookie = `${c_name}=${escape(value)};expires=${exdate};path=/;domain=${domain}`;
}
function get(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(`${c_name}=`);
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}
function del(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = get(name);
  const domain = getParseDomain();
  if (cval != null) {
    document.cookie = `${name}=${cval};expires=${exp.toUTCString()};path=/;domain=${domain}`;
  }
}
// 获取设置cookie的domain（和后端设置逻辑保持统一）
// 适配多域名，设置 cookie 到一级域名
function getParseDomain(beforeDomain) {
  let hostname = location.hostname.toLocaleLowerCase();
  // 获取一级域名
  const arr = hostname.split(".");
  hostname = arr.length > (hostname.includes(".com.cn") ? 3 : 2) ? arr.slice(1).join(".") : hostname;
  let domain = beforeDomain || hostname;
  const reLocalhost = /^(192.168.)|^(127.0.0.)/;
  if (reLocalhost.test(domain)) {
    // domain = domain;
  } else if (domain === "localhost") {
    domain = hostname;
  } else {
    domain = `.${domain}`;
  }
  return domain;
}

// 验证字符串str是否为日期格式的字符串
function isDate(str) {
  const reg = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
  if (!str) return false;
  if (reg.test(str) && RegExp.$2 <= 12 && RegExp.$3 <= 31 && RegExp.$4 <= 23 && RegExp.$5 <= 59 && RegExp.$6 <= 59) {
    return true;
  }
  return false;
}

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpMemberPackageInfo; });
/* unused harmony export httpPackageList */
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

let request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

/**
 * 获取用户现有套餐版本
 * @returns
 */
function httpMemberPackageInfo(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/plugin/api/v1/member_package/info/", {
    ...params
  });
}

/**
 * 获取各种套餐详细内容
 * @returns
 */
function httpPackageList() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/plugin/api/v1/package/info/");
}

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/index.vue?vue&type=template&id=401cf2ae&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoading && !_vm.isPackageLoading
    ? _c(
        "div",
        [
          _vm.visible && !_vm.isWAUser
            ? _c(
                "div",
                {
                  staticClass: "package-dialog mask",
                  style: { zIndex: _vm.zIndex }
                },
                [
                  _c("div", { staticClass: "inner" }, [
                    _c("div", { staticClass: "account" }, [
                      _c("div", { staticClass: "user-part" }, [
                        _c("img", {
                          staticClass: "user-avator",
                          attrs: {
                            src: _vm.userInfo.portrait,
                            alt: "问卷网用户头像"
                          }
                        }),
                        _vm._v(" "),
                        _c("section", { staticClass: "right-info" }, [
                          _c("p", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.userInfo.nickname || _vm.userInfo.username
                                ) +
                                "\n                            "
                            ),
                            _vm.phoneNum
                              ? _c("span", { staticClass: "phone-star-num" }, [
                                  _vm._v("（" + _vm._s(_vm.phoneNum) + "）")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "version-icon",
                            class: [
                              _vm.currentVersion === "free" ? "free" : "",
                              _vm.currentVersion === "advance_version"
                                ? "advance-version"
                                : "",
                              _vm.currentVersion === "enterprise_version"
                                ? "enterprise-version"
                                : "",
                              _vm.currentVersion ===
                              "enterprise_ultimate_version"
                                ? "enterprise-ultimate-version"
                                : ""
                            ],
                            attrs: { "data-typeicon": _vm.currentVersion }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "close-icon wj-icon-close",
                        on: {
                          click: function($event) {
                            return _vm.$emit("input", false)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c("PackageDetail", {
                          staticClass: "pkgs",
                          attrs: {
                            "version-list": _vm.versionList,
                            "active-version": _vm.innerActiveVersion,
                            "active-time": _vm.activeTime,
                            "active-equity": _vm.activeEquity,
                            "rest-indate": _vm.restIndate,
                            "service-qrcode": _vm.serviceQrcode,
                            "service-num": _vm.serviceNum,
                            "is-pkg-upgrad": _vm.isPkgUpgrad,
                            goods_id: _vm.goods_id
                          },
                          on: {
                            "update:goods_id": function($event) {
                              _vm.goods_id = $event
                            },
                            changeVersion: _vm.changeVersion
                          }
                        }),
                        _vm._v(" "),
                        _c("payment", {
                          attrs: {
                            "is-pkg-upgrad": _vm.isPkgUpgrad,
                            disabled: _vm.disableUpgrade,
                            "pay-version": _vm.innerActiveVersion,
                            "pay-time": _vm.activeTime,
                            "coupon-list": _vm.coupons,
                            "current-version": _vm.currentVersion,
                            "current-version-expire-time": _vm.restIndate,
                            "current-version-sub-account":
                              _vm.currentSubAccount,
                            "service-qrcode": _vm.serviceQrcode,
                            "z-index": _vm.zIndex,
                            "confirm-zindex": _vm.confirmZindex,
                            "is-free-try": _vm.microAppInfo.isFreeTry,
                            goods_id: _vm.goods_id
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm.visible && _vm.isWAUser
            ? _c(
                "wd-dialog",
                {
                  attrs: {
                    title: "套餐购买操作指引",
                    visible: _vm.dialogVisile
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisile = $event
                    },
                    close: function($event) {
                      return _vm.$emit("input", false)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "pop-up-guide" }, [
                    _c("span", [_vm._v("请选择以下方式购买套餐")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(
                        "\n                1. " +
                          _vm._s(_vm.dialogInfo[_vm.isWAUser].description) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "2." +
                          _vm._s(_vm.dialogInfo[_vm.isWAUser].scanQR) +
                          "，添加问卷网客户顾问，获取更多支持\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "QR-Code" }, [
                      _c("img", {
                        staticClass: "QR",
                        attrs: {
                          src: _vm.dialogInfo[_vm.isWAUser][_vm.randomSale]
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: _vm.dialogInfo[_vm.isWAUser].iconImg,
                          alt: ""
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "wd-button",
                        {
                          attrs: { type: "primary", width: "100px" },
                          on: { click: _vm.JumpLink }
                        },
                        [_vm._v(_vm._s(_vm.jumpButton[_vm.isWAUser]))]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/package-dialog/src/index.vue?vue&type=template&id=401cf2ae&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/message.css"
var message_css_ = __webpack_require__(12);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/message"
var message_ = __webpack_require__(2);
var message_default = /*#__PURE__*/__webpack_require__.n(message_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dialog.css"
var dialog_css_ = __webpack_require__(14);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dialog"
var dialog_ = __webpack_require__(7);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/button.css"
var button_css_ = __webpack_require__(8);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/button"
var button_ = __webpack_require__(3);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(1);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./src/http/vue-package-dialog/index.js

let request = external_vue_default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

// 获取用户信息
function getUserInfo(data) {
  // data?.unInterceptors = true;
  request = external_vue_default.a.prototype.commonRequest;
  return request.get(`/member/api/info/simple/`, data);
}

// 获取钉钉corpId
function dingTalkCorpId(data) {
  return request.get(`/api/member/third_part/dingtalk/user_info/`, data);
}

/**
 * 查询可用优惠券
 * @param {"sub_account"|"advance_version"|"enterprise_version"|"enterprise_ultimate_version"} scope 优惠券使用范围
 * @returns
 */
function avaliableCoupons(scope) {
  request = external_vue_default.a.prototype.commonRequest;
  const formParams = new URLSearchParams();
  formParams.append("currency_type", "0|3");
  formParams.append("scope", scope);
  return request.post("/auth/ajax/get_currency_info/", formParams);
}

/**
 * 生成支付订单
 * @param {"alipay"|"wechatpay"} pay_channel 充值渠道
 * @param {number} amount_cent 充值金额，单位为分
 * @returns
 */
function payOrder(pay_channel, amount_cent) {
  request = external_vue_default.a.prototype.commonRequest;
  return request.post("/member/api/payorder/", {
    pay_channel,
    amount_cent
  });
}

/**
 * 获取订单支付状态
 * @param {string} order_id
 */
function payOrderStatus(order_id) {
  request = external_vue_default.a.prototype.commonRequest;
  return request.post("/member/api/validate_payorder/", {
    order_id
  });
}

/**
 * 获取各种套餐详细内容
 * @returns
 */
function httpPackageList() {
  request = external_vue_default.a.prototype.commonRequest;
  return request.get("/plugin/api/v1/package/info/");
}

/**
 * 升级/续费套餐，需要前置httpPackageList获取到各套餐的plugin_id等必要字段
 * @param {*} data
 * @returns
 */
function consumeOrder(data) {
  request = external_vue_default.a.prototype.commonRequest;
  const formParams = new URLSearchParams();
  for (const key of Object.keys(data)) {
    formParams.append(key, data[key]);
  }
  return request.post("/plugin/ajax/consume/", formParams);
}

/**
 * 获取服务顾问手机、二维码和对公转账二维码
 * @returns
 */
function getQrcodeInfo() {
  request = external_vue_default.a.prototype.commonRequest;
  return request.get("/api/call_center/admin/info");
}

// 获取企业信息
function getCorpInfo() {
  return request.get("/api/package/corp_info/");
}

/**
 * 购买弹窗立即支付按钮逻辑更新 生成支付订单
 * @returns
 */
function createOrder(params) {
  return request.post("/api/order/create/", {
    ...params
  });
}
// EXTERNAL MODULE: ./src/http/package-dialog/index.js
var package_dialog = __webpack_require__(50);

// EXTERNAL MODULE: ./packages/tools.js
var tools = __webpack_require__(11);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/payment.vue?vue&type=template&id=970e15d0&scoped=true&
var paymentvue_type_template_id_970e15d0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "package-payment" },
    [
      !_vm.disabled
        ? _c("div", { staticClass: "payment" }, [
            _c("div", { staticClass: "cost-wrap" }, [
              _c("div", { staticClass: "cost" }, [
                _c("span", { staticClass: "symbol" }, [_vm._v("￥")]),
                _vm._v(" "),
                _c("span", { staticClass: "price" }, [
                  _vm._v(_vm._s(_vm.actualPayCost))
                ])
              ]),
              _vm._v(" "),
              _vm.subAcconutNum > 0
                ? _c("div", { staticClass: "sub_account" }, [
                    _c(
                      "div",
                      { staticClass: "label" },
                      [
                        _c("span", [_vm._v("子账号数量")]),
                        _vm._v(" "),
                        _c(
                          "wd-tooltip",
                          { attrs: { placement: "top", effect: "light" } },
                          [
                            _c("img", {
                              staticClass: "icon-help",
                              attrs: { src: _vm.IconQuestion }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  "\n                            子账号数量不得低于赠送的子账"
                                ),
                                _c("br"),
                                _vm._v("号数量和您正在使用的子账号数"),
                                _c("br"),
                                _vm._v("量\n                        ")
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "account_num" }, [
                      _vm._v(_vm._s(_vm.subAcconutNum))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("ul", { staticClass: "cost_info" }, [
                _c("li", [
                  _c("span", [_vm._v("账号套餐费用")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.costPrice) + "元")])
                ]),
                _vm._v(" "),
                _vm.subAccountCost > 0
                  ? _c("li", [
                      _c("span", [_vm._v("子账号增购费用")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.subAccountCost) + "元")])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.versionDeduction > 0
                  ? _c("li", [
                      _c(
                        "div",
                        { staticClass: "version_wroth" },
                        [
                          _c("span", [_vm._v("版本升级抵扣")]),
                          _vm._v(" "),
                          _c(
                            "wd-tooltip",
                            { attrs: { placement: "top", effect: "light" } },
                            [
                              _c("img", {
                                staticClass: "icon-help",
                                attrs: { src: _vm.IconQuestion }
                              }),
                              _vm._v(" "),
                              _c(
                                "p",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(
                                    "\n                                我们会按照您原先付费版本的年"
                                  ),
                                  _c("br"),
                                  _vm._v("付价格及该版本的剩余有效时"),
                                  _c("br"),
                                  _vm._v(
                                    "长，为您抵扣相应金额\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("-" + _vm._s(_vm.versionDeduction) + "元")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.subAccountDeduction > 0
                  ? _c("li", [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("-" + _vm._s(_vm.subAccountDeduction) + "元")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.avaliableCoupons.length > 0
                  ? _c(
                      "li",
                      [
                        _c(
                          "wd-dropdown",
                          {
                            attrs: { trigger: "click" },
                            on: { command: _vm.selectCoupon }
                          },
                          [
                            _c("div", { staticClass: "coupon" }, [
                              _c("span", [
                                _vm._v(
                                  "\n                                优惠券"
                                ),
                                _c("i", { staticClass: "wd-icon-caret-bottom" })
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("-" + _vm._s(_vm.couponDeduction) + "元")
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "wd-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              _vm._l(_vm.avaliableCoupons, function(coupon, i) {
                                return _c(
                                  "wd-dropdown-item",
                                  {
                                    key: `coupon-${i}`,
                                    attrs: { command: coupon }
                                  },
                                  [
                                    _c("span", [_vm._v("优惠券")]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("-" + _vm._s(coupon.value) + "元")
                                    ])
                                  ]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "font_bold" }, [
                    _vm._v("实际支付")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font_bold" }, [
                    _vm._v(_vm._s(_vm.actualPayCost) + "元")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pay_area" }, [
              _c("p", [
                _c("span", { staticClass: "font_bold" }, [_vm._v("支付方式")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "font_light",
                    on: { click: _vm.openPublicAccount }
                  },
                  [
                    _vm._v("对公转账 "),
                    _c("i", { staticClass: "wd-icon-arrow-right" })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("p", { staticStyle: { "margin-top": "8px" } }, [
                _c("button", {
                  staticClass: "pay_way alipay",
                  class: { inactive: _vm.payWayIndex === 1 },
                  on: {
                    click: function($event) {
                      return _vm.changePayWay(0)
                    }
                  }
                }),
                _vm._v(" "),
                _c("button", {
                  staticClass: "pay_way wechat",
                  class: { inactive: _vm.payWayIndex === 0 },
                  on: {
                    click: function($event) {
                      return _vm.changePayWay(1)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "pay_btn" },
                [
                  _c(
                    "wd-button",
                    { attrs: { type: "danger" }, on: { click: _vm.payNow } },
                    [_vm._v("立即支付")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "pay_extra_info" }, [
                _vm._v("购买后有效期至 " + _vm._s(_vm.pkgDeadTime))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "wd-dialog",
        {
          staticClass: "contact-service-counselor",
          attrs: {
            title: "联系对公顾问",
            visible: _vm.dialogVisible,
            "show-close": false,
            width: "280px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "content-contact" }, [
            _c("p", { staticClass: "line-title" }, [
              _vm._v("请使用微信扫一扫联系对公顾问")
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "wx-ercode",
              attrs: { src: _vm.serviceQrcode, alt: "服务顾问" }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ok-btn",
                on: {
                  click: function($event) {
                    _vm.dialogVisible = false
                  }
                }
              },
              [_vm._v("\n                好的\n            ")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var paymentvue_type_template_id_970e15d0_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "version_wroth" }, [
      _c("span", [_vm._v("子账号升级抵扣")])
    ])
  }
]
paymentvue_type_template_id_970e15d0_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/package-dialog/src/payment.vue?vue&type=template&id=970e15d0&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/message-box.css"
var message_box_css_ = __webpack_require__(34);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/message-box"
var message_box_ = __webpack_require__(13);
var message_box_default = /*#__PURE__*/__webpack_require__.n(message_box_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dropdown-item.css"
var dropdown_item_css_ = __webpack_require__(127);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dropdown-item"
var dropdown_item_ = __webpack_require__(28);
var dropdown_item_default = /*#__PURE__*/__webpack_require__.n(dropdown_item_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dropdown-menu.css"
var dropdown_menu_css_ = __webpack_require__(128);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dropdown-menu"
var dropdown_menu_ = __webpack_require__(29);
var dropdown_menu_default = /*#__PURE__*/__webpack_require__.n(dropdown_menu_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dropdown.css"
var dropdown_css_ = __webpack_require__(129);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dropdown"
var dropdown_ = __webpack_require__(30);
var dropdown_default = /*#__PURE__*/__webpack_require__.n(dropdown_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/input-number.css"
var input_number_css_ = __webpack_require__(147);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/input-number"
var input_number_ = __webpack_require__(45);
var input_number_default = /*#__PURE__*/__webpack_require__.n(input_number_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/tooltip.css"
var tooltip_css_ = __webpack_require__(40);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/tooltip"
var tooltip_ = __webpack_require__(21);
var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);

// EXTERNAL MODULE: external "dayjs"
var external_dayjs_ = __webpack_require__(43);
var external_dayjs_default = /*#__PURE__*/__webpack_require__.n(external_dayjs_);

// CONCATENATED MODULE: ./src/assets/js/vue-package-dialog/info-config.js
// 用户套餐版本对应中文
const MEMBER_PKG_TYPE_MAPPING = {
  free: "基础版",
  advance_version: "高级版",
  enterprise_version: "企业版",
  enterprise_ultimate_version: "旗舰版",
  enterprise_ultimate_free_version: "旗舰版（试用）"
};

// 各套餐对应价格
const packagePrice = {
  advance_version: [{
    indate: 1,
    totalPrice: 2499,
    averagePrice: 6.9,
    goods_id: "6540a51a8b3d75612d17220e"
  }, {
    indate: 3,
    totalPrice: 7497,
    averagePrice: 5.2,
    goods_id: "6540a51a8b3d75612d17220f"
  }, {
    indate: 5,
    totalPrice: 12495,
    averagePrice: 4.9,
    goods_id: "6540a51a8b3d75612d172210"
  }],
  enterprise_version: [{
    indate: 1,
    totalPrice: 5499,
    averagePrice: 1.6,
    goods_id: "6540a51a8b3d75612d172211"
  }, {
    indate: 3,
    totalPrice: 16497,
    averagePrice: 1.2,
    goods_id: "6540a51a8b3d75612d172212"
  }, {
    indate: 5,
    totalPrice: 27495,
    averagePrice: 1.1,
    goods_id: "6540a51a8b3d75612d172213"
  }],
  enterprise_ultimate_version: [{
    indate: 1,
    totalPrice: 24999,
    averagePrice: 2.3,
    goods_id: "6540a51a8b3d75612d172214"
  }, {
    indate: 3,
    totalPrice: 74997,
    averagePrice: 1.8,
    goods_id: "6540a51a8b3d75612d172215"
  }, {
    indate: 5,
    totalPrice: 124995,
    averagePrice: 1.7,
    goods_id: "6540a51a8b3d75612d172216"
  }]
};

// 付费版本简介
const payVersionList = [{
  name: "高级版",
  key: "advance_version",
  intro: "适用有去广告需求的用户"
}, {
  name: "企业标准版",
  key: "enterprise_version",
  intro: "适用有解决方案需求的企业"
}, {
  name: "企业旗舰版",
  key: "enterprise_ultimate_version",
  intro: "适用团队30人以上的企业"
}];
// advance_version: '高级版',
// advance_free_version: '高级版(试用版)',
// enterprise_version: '企业版',
// enterprise_free_version: '企业版(试用版)',
// enterprise_ultimate_free_version: '企业旗舰版(试用版)',
// enterprise_ultimate_version: '企业旗舰版',
const payVersionListProxy = {
  advance_version: "advance_version",
  advance_free_version: "advance_version",
  enterprise_version: "enterprise_version",
  enterprise_free_version: "enterprise_free_version",
  enterprise_ultimate_version: "enterprise_ultimate_version",
  enterprise_ultimate_free_version: "enterprise_ultimate_version"
};

// 各套餐展示权益
const packageShowEquity = {
  advance_version: [{
    key: "advertising-free",
    text: "免广告10万次"
  }, {
    key: "hide-logo",
    text: "隐藏问卷支持"
  }, {
    key: "lottery",
    text: "自定义抽奖"
  }, {
    key: "voting-wall",
    text: "投票墙"
  }, {
    key: "wx-sign-in",
    text: "微信签到"
  }, {
    key: "upload-multi-media",
    text: "上传音频/视频"
  }, {
    key: "single-upload-size",
    text: "单个文件50MB"
  }, {
    key: "upload-total-size",
    text: "上传空间10GB"
  }, {
    key: "geographical_navigate",
    text: "位置/导航题"
  },
  // { key: "export-volume-unlimited", text: "不限数据导出量" }
  {
    key: "assess-anti-cheating",
    text: "考试防作弊"
  }],
  enterprise_version: [{
    key: "advertising-free",
    text: "免广告30万次"
  },
  // { key: "hide-logo", text: "隐藏问卷支持" },
  {
    key: "ent-cooperation",
    text: "团队成员10位"
  }, {
    key: "large-vote",
    text: "大型投票"
  }, {
    key: "360-appraise",
    text: "360评估"
  },
  // { key: "export-volume-unlimited", text: "不限数据导出量" }
  {
    key: "assess-anti-cheating",
    text: "考试防作弊"
  },
  // { key: "export-answer-collection", text: "可导出答卷集合" },
  {
    key: "lottery",
    text: "自定义抽奖"
  }, {
    key: "single-upload-size",
    text: "单个文件100MB"
  }, {
    key: "upload-total-size",
    text: "上传空间20GB"
  }, {
    key: "brand-show",
    text: "企业品牌展示"
  }, {
    key: "open-api",
    text: "开放平台"
  }],
  enterprise_ultimate_version: [{
    key: "advertising-free",
    text: "免广告150万次"
  },
  // { key: "hide-logo", text: "隐藏问卷支持" },
  {
    key: "ent-cooperation",
    text: "团队成员30位"
  }, {
    key: "large-vote",
    text: "大型投票"
  }, {
    key: "360-appraise",
    text: "360评估"
  },
  // { key: "export-volume-unlimited", text: "不限数据导出量" },
  {
    key: "assess-anti-cheating",
    text: "考试防作弊"
  },
  // { key: "export-answer-collection", text: "可导出答卷集合" },
  {
    key: "lottery",
    text: "自定义抽奖"
  }, {
    key: "single-upload-size",
    text: "单个文件200MB"
  }, {
    key: "upload-total-size",
    text: "上传空间50GB"
  }, {
    key: "brand-show",
    text: "企业品牌展示"
  }, {
    key: "open-api",
    text: "开放平台"
  }]
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/payment.vue?vue&type=script&lang=js&





















const defaultSubAccount = {
  free: 0,
  advance_version: 0,
  enterprise_version: 10,
  enterprise_ultimate_version: 30
};
/* harmony default export */ var paymentvue_type_script_lang_js_ = ({
  components: {
    [tooltip_default.a.name]: tooltip_default.a,
    [input_number_default.a.name]: input_number_default.a,
    [dropdown_default.a.name]: dropdown_default.a,
    [dropdown_menu_default.a.name]: dropdown_menu_default.a,
    [dropdown_item_default.a.name]: dropdown_item_default.a,
    [button_default.a.name]: button_default.a,
    [dialog_default.a.name]: dialog_default.a
  },
  props: {
    // 是否禁止操作，当用户无法选择升级套餐时，会隐藏所有信息
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否升级套餐
    isPkgUpgrad: {
      type: Boolean,
      default: false
    },
    // 当前账号套餐版本
    currentVersion: {
      type: String,
      default: ""
    },
    // 当前账号套餐到期时间(天)
    currentVersionExpireTime: {
      type: Number,
      default: 0
    },
    // // 当前账号套餐版本的子账号
    currentVersionSubAccount: {
      type: Number,
      default: 0
    },
    // 支付的套餐版本
    payVersion: {
      type: String,
      default: ""
    },
    // 支付的套餐年数
    payTime: {
      type: Number,
      default: 0
    },
    // 支付的套餐优惠券列表
    couponList: {
      type: Array,
      default: () => []
    },
    serviceQrcode: {
      type: String,
      default: ""
    },
    // 是不是需要自动提高Messasge
    zIndex: {
      type: Number,
      default: null
    },
    // 最高级解决层级问题，手动解决层级问题
    confirmZindex: {
      type: Number,
      default: null
    },
    // 当前套餐是否为试用版，试用版参与不抵扣
    isFreeTry: {
      type: Boolean,
      default: false
    },
    // 套餐goods_id
    goods_id: {
      type: String,
      default: ""
    }
  },
  data() {
    const appendUrl = this.$parent.appendUrl || "";
    return {
      IconQuestion: `${appendUrl}question.png`,
      payWays: ["alipay", "wechatpay"],
      payWayIndex: 0,
      checkedCoupon: null,
      dialogVisible: false,
      peerAccountCost: 500,
      // 一个增购子账号一年的价格
      pkgYearDays: 365 // 套餐购买/抵扣时计算的一年天数
    };
  },

  computed: {
    // 套餐标准费用
    costPrice() {
      var _packagePrice$this$pa;
      return (_packagePrice$this$pa = packagePrice[this.payVersion].find(v => v.indate === this.payTime)) === null || _packagePrice$this$pa === void 0 ? void 0 : _packagePrice$this$pa.totalPrice;
    },
    // 当前套餐默认赠送的子账号数量
    currentPkgDefaultAccount() {
      return defaultSubAccount[this.currentVersion];
    },
    // 选中套餐默认赠送的子账号数量
    payPkgDefaultAccount() {
      return defaultSubAccount[this.payVersion];
    },
    // 子账号数量
    subAcconutNum() {
      if (this.payPkgDefaultAccount === 0) {
        return 0;
      }
      // 当前套餐如果有子账号，则取当前套餐的子账号数量和已选套餐默认赠送的最大值
      return Math.max(this.currentVersionSubAccount, this.payPkgDefaultAccount);
    },
    // 子账号增购费用，比套餐赠送数量多的部分
    subAccountCost() {
      return (this.subAcconutNum - this.payPkgDefaultAccount) * this.peerAccountCost * this.payTime;
    },
    // 当前套餐版本费用抵扣，保留小数后2位
    versionDeduction() {
      var _packagePrice$this$cu;
      // 试用版不抵扣
      if (this.isFreeTry) {
        return 0;
      }
      // 续费不抵扣
      if (!this.isPkgUpgrad) {
        return 0;
      }
      // 非高级版、企业版不抵扣
      if (this.currentVersion !== "advance_version" && this.currentVersion !== "enterprise_version") {
        return 0;
      }
      const pricePerYear = (_packagePrice$this$cu = packagePrice[this.currentVersion][0]) === null || _packagePrice$this$cu === void 0 ? void 0 : _packagePrice$this$cu.totalPrice;

      // 保留2位小数，四舍五入
      // 11.27套餐重构取消四舍五入
      let r = (this.currentVersionExpireTime / this.pkgYearDays * pricePerYear).toString();
      r = (r.includes(".") ? r.substring(0, r.indexOf(".") + 3) : r) - 0;
      return r;
    },
    // 当前套餐版本增购的子账号抵扣，保留小数后2位
    subAccountDeduction() {
      return 0;

      // 产品要求：去除掉所有抵扣费用
      //
      // // 续费不抵扣
      // if (!this.isPkgUpgrad) {
      //     return 0;
      // }
      // // 非企业版、期间版不抵扣
      // if (
      //     this.currentVersion !== "enterprise_version" &&
      //     this.currentVersion !== "enterprise_ultimate_version"
      // ) {
      //     return 0;
      // }

      // // 保留2位小数，四舍五入
      // let r =
      //     (this.currentVersionExpireTime / this.pkgYearDays) *
      //     this.peerAccountCost *
      //     (this.currentVersionSubAccount - this.currentPkgDefaultAccount);
      // r = r.toFixed(2) - 0;
      // return r;
    },

    // 选中的优惠券面额
    couponDeduction() {
      var _this$checkedCoupon;
      return (_this$checkedCoupon = this.checkedCoupon) === null || _this$checkedCoupon === void 0 ? void 0 : _this$checkedCoupon.value;
    },
    // 实际支付费用
    actualPayCost() {
      let r = this.costPrice + this.subAccountCost - this.versionDeduction - this.subAccountDeduction - this.couponDeduction;

      // 保留2位小数，四舍五入
      r = r.toFixed(2) - 0;
      return Math.max(r, 0);
    },
    // 支付的套餐版本过期时间
    pkgDeadTime() {
      if (this.isPkgUpgrad) {
        return this.daysToDate();
      }
      return this.daysToDate(this.currentVersionExpireTime);
    },
    payWay() {
      return this.payWays[this.payWayIndex];
    },
    // 优惠券有使用门槛，支付金额(除优惠券以外的部分)必须大于等于优惠券最低门槛价格
    avaliableCoupons() {
      const payCost = this.costPrice + this.subAccountCost - this.versionDeduction - this.subAccountDeduction;
      return this.couponList.filter(v => {
        const satisfyV = Number.isNaN(Number.parseFloat(v.satisfy_value)) ? 0 : Number.parseFloat(v.satisfy_value);
        return payCost >= satisfyV;
      });
    }
  },
  watch: {
    avaliableCoupons: {
      handler(v) {
        if (v.length > 0) {
          let maxCoupon = v[0];
          // 当优惠券列表更新，默认取最大面值
          // eslint-disable-next-line no-restricted-syntax
          for (const coupon of v) {
            if (maxCoupon.value < coupon.value) {
              maxCoupon = coupon;
            }
          }
          this.selectCoupon(maxCoupon);
        } else {
          this.selectCoupon({
            value: 0,
            oid: ""
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    // 套餐过期时间转换
    daysToDate() {
      let initDays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      // 满3送1，满5送2
      const yearsMap = {
        1: 1,
        3: 4,
        5: 7
      };
      const years = yearsMap[this.payTime];
      return external_dayjs_default()().add(initDays, "d").add(years * this.pkgYearDays, "d").format("YYYY-MM-DD");
    },
    // 修改支付方式
    changePayWay(i) {
      this.payWayIndex = i;
    },
    // 选择优惠券
    selectCoupon(v) {
      this.checkedCoupon = v;
    },
    // 调起支付
    async payNow() {
      if (this.payNow.user) return;
      this.payNow.user = true;
      setTimeout(() => {
        this.payNow.user = false;
      }, 200);
      let checkPamentTicker = null;
      try {
        var _res$data, _res$data2, _res$data3, _res$data5;
        const res = await createOrder({
          cargo_to_buy: [{
            goods_id: this.goods_id,
            amount: 1
          }],
          payment_info: [{
            pay_channel: ["alipay", "wechatpay"].indexOf(this.payWay) + 1,
            cent_to_pay: (this.actualPayCost * 100).toFixed() - 0
          }],
          coupon_to_use: this.checkedCoupon.oid ? [this.checkedCoupon.oid] : []
        });
        if (!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.is_success)) return;

        // 使用优惠券实际支付金额小于等于0时且购买成功时 不返回order_id
        if (!((_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.order_id)) {
          this.afterPayment(true);
          return;
        }

        // 接口返回pay_redirect_url 新开支付页面
        ((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.pay_redirect_url) && window.open(res.data.pay_redirect_url, "_blank");

        // // 开启轮询，只是为了保证二次确认弹窗还在的时候，用户支付成功，自动关闭弹窗
        // // 一旦二次确认弹窗关闭（无论点击确定还是取消），都会取消轮询
        checkPamentTicker = setInterval(async () => {
          try {
            var _res$data4;
            await this.checkPayment((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.order_id);
            // 如果轮询检查支付成功，关闭轮询，关闭弹窗
            clearInterval(checkPamentTicker);
            // 手动关闭支付确认弹窗
            message_box_default.a.close();
            this.afterPayment(true);
          } catch (error) {
            //
          }
        }, 3000);
        await message_box_default.a.confirm("支付完成前，请勿关闭此窗口<br />支付完成后，请根据支付情况点击以下按钮", "支付成功确认", {
          confirmButtonText: "支付成功",
          closeOnPressEscape: false,
          dangerouslyUseHTMLString: true,
          ...(this.confirmZindex || this.zIndex ? {
            zIndex: this.confirmZindex || this.zIndex + 1
          } : null)
        });
        await this.checkPayment((_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.order_id);
        this.afterPayment(true);
      } catch (error) {
        // 支付过程中产生的所有错误，不包括用户取消支付确认
        if (error !== "cancel") {
          this.afterPayment(false);
        }
        console.log("payment errors: ", error);
      }

      // 只要用户操作了二次确认弹窗，弹窗关闭后，则关闭轮询
      clearInterval(checkPamentTicker);
    },
    // 检查订单是否支付成功，如果成功则购买，否则返回错误
    async checkPayment(order_id) {
      try {
        const {
          data
        } = await payOrderStatus(order_id);
        if ((data === null || data === void 0 ? void 0 : data.order_status) === 1) {
          // await this.buyPackage(order_id);
          console.log("购买成功");
        } else {
          return Promise.reject(new Error("checkPayment faild."));
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    // 支付之后
    afterPayment() {
      let successful = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (successful) {
        message_default()({
          message: "支付成功",
          type: "success"
        });
        this.$parent.$emit("input", false);
        this.$parent.$emit("payment", true);
        if (this.$parent.needReload) {
          window.location.reload();
        }
      } else {
        message_default()({
          message: "您未完成支付",
          type: "warning"
        });
        this.$parent.$emit("payment", false);
      }
    },
    // 打卡对公转账弹框
    openPublicAccount() {
      this.dialogVisible = true;
    }
  }
});
// CONCATENATED MODULE: ./packages/package-dialog/src/payment.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_paymentvue_type_script_lang_js_ = (paymentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/payment.vue?vue&type=style&index=0&id=970e15d0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/package-dialog/src/payment.vue?vue&type=style&index=0&id=970e15d0&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/package-dialog/src/payment.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_paymentvue_type_script_lang_js_,
  paymentvue_type_template_id_970e15d0_scoped_true_render,
  paymentvue_type_template_id_970e15d0_scoped_true_staticRenderFns,
  false,
  null,
  "970e15d0",
  null
  
)

/* harmony default export */ var payment = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/package-detail.vue?vue&type=template&id=045de84d&scoped=true&
var package_detailvue_type_template_id_045de84d_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "package-detail",
      class: [
        {
          "three-left":
            _vm.showVersionList.length === 3 &&
            _vm.activeVersion === "advance_version"
        },
        {
          "three-center":
            _vm.showVersionList.length === 3 &&
            _vm.activeVersion === "enterprise_version"
        },
        {
          "three-right":
            _vm.showVersionList.length === 3 &&
            _vm.activeVersion === "enterprise_ultimate_version"
        },
        {
          "two-left":
            _vm.versionList.length === 1 ||
            (_vm.versionList.length === 2 &&
              _vm.activeVersion === "enterprise_version")
        },
        {
          "two-right":
            _vm.showVersionList.length === 2 &&
            _vm.activeVersion === "enterprise_ultimate_version" &&
            _vm.showVersionList[0].key === "enterprise_version"
        }
      ]
    },
    [
      _c(
        "ul",
        { staticClass: "tabs" },
        _vm._l(_vm.showVersionList, function(item) {
          return _c(
            "li",
            {
              key: item.key,
              staticClass: "tab",
              on: {
                click: function($event) {
                  return _vm.changePackage(item)
                }
              }
            },
            [
              _c("h3", { staticClass: "name" }, [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              _c("p", { staticClass: "intro" }, [_vm._v(_vm._s(item.intro))])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "detail-part" }, [
        _c(
          "ul",
          { staticClass: "price-part", class: [] },
          _vm._l(_vm.packagePriceList, function(item, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "every-time",
                class: [
                  _vm.restIndate > item.indate * 365 && _vm.isPkgUpgrad
                    ? "disabled"
                    : "",
                  item.indate == _vm.activeTime ? "active" : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.changeTime(item)
                  }
                }
              },
              [
                _c("span", {
                  staticClass: "give-icon",
                  class: [
                    { one: item.indate === 3 },
                    { two: item.indate === 5 }
                  ]
                }),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "year" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.indate) +
                        "年\n                    "
                    ),
                    _vm.restIndate > item.indate * 365 && _vm.isPkgUpgrad
                      ? _c(
                          "wd-tooltip",
                          { attrs: { placement: "top", effect: "light" } },
                          [
                            _c("img", {
                              staticClass: "icon-help",
                              attrs: { src: _vm.IconQuestion }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  "\n                            账号套餐升级时的购买时长不得"
                                ),
                                _c("br"),
                                _vm._v(
                                  "低于原套餐的剩余有效时长\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "total-money" }, [
                  _c("span", { staticClass: "rmb" }, [_vm._v("￥")]),
                  _vm._v(_vm._s(item.totalPrice) + "\n                ")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "day-money" }, [
                  _vm._v(
                    "\n                    低至日均" +
                      _vm._s(item.averagePrice) +
                      "元"
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeVersion !== "advance_version",
                          expression: "activeVersion !== 'advance_version'"
                        }
                      ]
                    },
                    [_vm._v("/人")]
                  )
                ])
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "equity-part" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "equity-ul" },
            _vm._l(_vm.equityList, function(item) {
              return _c(
                "li",
                {
                  key: item.key,
                  staticClass: "equity-li",
                  class: [_vm.activeEquity === item.key ? "active" : ""]
                },
                [
                  _c("span", {
                    staticClass: "equity-icon",
                    attrs: { "data-type": item.key }
                  }),
                  _vm._v(" "),
                  _c("span", { class: item.key }, [_vm._v(_vm._s(item.text))])
                ]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "contact-service",
            on: { click: _vm.showServiceDialog }
          },
          [
            _c("span", { staticClass: "service-icon" }),
            _vm._v(" "),
            _c("span", [_vm._v("联系服务顾问")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "wd-dialog",
        {
          staticClass: "contact-service-counselor",
          attrs: {
            title: "联系服务顾问",
            visible: _vm.serviceShow,
            "show-close": false,
            width: "280px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.serviceShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "content-contact" }, [
            _c("p", { staticClass: "line-title" }, [_vm._v("电话联系")]),
            _vm._v(" "),
            _c("p", { staticClass: "phone-num" }, [
              _vm._v(_vm._s(_vm.serviceNum || "02180394911"))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "line-title" }, [_vm._v("微信联系")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "wx-ercode",
              attrs: { src: _vm.serviceQrcode, alt: "服务顾问" }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ok-btn",
                on: {
                  click: function($event) {
                    _vm.serviceShow = false
                  }
                }
              },
              [_vm._v("\n                好的\n            ")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var package_detailvue_type_template_id_045de84d_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "equity-title" }, [
      _c("h3", [_vm._v("套餐权益")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "go-senior",
          attrs: { href: "/senior_user/", target: "_blank" }
        },
        [_vm._v("全部权益"), _c("span", { staticClass: "right-icon" })]
      )
    ])
  }
]
package_detailvue_type_template_id_045de84d_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/package-dialog/src/package-detail.vue?vue&type=template&id=045de84d&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/package-detail.vue?vue&type=script&lang=js&





/* harmony default export */ var package_detailvue_type_script_lang_js_ = ({
  name: "PackageDetail",
  components: {
    "wd-dialog": dialog_default.a,
    "wd-tooltip": tooltip_default.a
  },
  props: {
    // 当前高亮版本
    activeVersion: {
      type: String,
      default: "enterprise_ultimate_version"
    },
    // 当前高亮购买时长
    activeTime: {
      type: Number,
      default: 1
    },
    // 高亮的权益
    activeEquity: {
      type: String,
      default: ""
    },
    // 用户当前套餐剩余的有效期
    restIndate: {
      type: Number,
      default: 0
    },
    // 展示的版本列表
    versionList: {
      type: Array,
      default: () => payVersionList
    },
    // 服务顾问二维码
    serviceQrcode: {
      type: String,
      default: ""
    },
    serviceNum: {
      type: String,
      default: ""
    },
    // 是否升级套餐
    isPkgUpgrad: {
      type: Boolean,
      default: false
    },
    // 套餐goods_id
    goods_id: {
      type: String,
      default: ""
    }
  },
  data() {
    const appendUrl = this.$parent.appendUrl || "";
    return {
      appendUrl,
      IconQuestion: `${appendUrl}question-disabled.png`,
      serviceShow: false // 服务顾问弹框显隐
    };
  },

  computed: {
    // 选中的套餐版本
    selectedVersion: {
      get() {
        return this.activeVersion;
      },
      set(val) {
        this.$emit("changeVersion", {
          activeVersion: val,
          activeTime: this.selectedTime
        });
      }
    },
    // 选中的购买时长
    selectedTime: {
      get() {
        return this.activeTime;
      },
      set(val) {
        this.$emit("changeVersion", {
          activeVersion: this.activeVersion,
          activeTime: val
        });
      }
    },
    // 权益列表
    equityList() {
      return packageShowEquity[this.selectedVersion];
    },
    // 购买时长和价格数组
    packagePriceList() {
      return packagePrice[this.activeVersion];
    },
    showVersionList() {
      if (this.versionList.length === 1) {
        return this.versionList.concat({});
      }
      return this.versionList;
    }
  },
  watch: {
    activeTime: {
      handler() {
        var _packagePrice$this$ac;
        this.$emit("update:goods_id", (_packagePrice$this$ac = packagePrice[this.activeVersion].find(item => item.indate == this.activeTime)) === null || _packagePrice$this$ac === void 0 ? void 0 : _packagePrice$this$ac.goods_id);
      },
      immediate: true
    },
    activeVersion: {
      handler() {
        var _packagePrice$this$ac2;
        this.$emit("update:goods_id", (_packagePrice$this$ac2 = packagePrice[this.activeVersion].find(item => item.indate == this.activeTime)) === null || _packagePrice$this$ac2 === void 0 ? void 0 : _packagePrice$this$ac2.goods_id);
      }
    }
  },
  methods: {
    // 切换套餐
    changePackage(item) {
      if (item && item.key) {
        this.selectedVersion = item.key;
        item.selectedTime = this.activeTime;
      }
    },
    // 切换有效期
    changeTime(item) {
      if (this.restIndate > item.indate * 365 && this.isPkgUpgrad) {
        return;
      }
      this.selectedTime = item.indate;
    },
    showServiceDialog() {
      this.serviceShow = true;
    }
  }
});
// CONCATENATED MODULE: ./packages/package-dialog/src/package-detail.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_package_detailvue_type_script_lang_js_ = (package_detailvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/package-detail.vue?vue&type=style&index=0&id=045de84d&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/package-dialog/src/package-detail.vue?vue&type=style&index=0&id=045de84d&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/package-dialog/src/package-detail.vue






/* normalize component */

var package_detail_component = Object(componentNormalizer["a" /* default */])(
  src_package_detailvue_type_script_lang_js_,
  package_detailvue_type_template_id_045de84d_scoped_true_render,
  package_detailvue_type_template_id_045de84d_scoped_true_staticRenderFns,
  false,
  null,
  "045de84d",
  null
  
)

/* harmony default export */ var package_detail = (package_detail_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/index.vue?vue&type=script&lang=js&












/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "PackageDialog",
  components: {
    "wd-button": button_default.a,
    "wd-dialog": dialog_default.a,
    payment: payment,
    PackageDetail: package_detail
  },
  model: {
    prop: "visible"
  },
  props: {
    // 是否展示弹窗，可以用v-model绑定
    visible: {
      type: Boolean,
      default: false
    },
    // 弹框要展示的最低版本,
    // eg:
    // 当前版本free，升级当前套餐，正常是从高级版显示
    // 如果lowestVersion是enterprise_version，则只展示企业版、旗舰版
    lowestVersion: {
      type: String,
      default: "advance_version",
      validator(v) {
        return ["advance_version", "enterprise_version", "enterprise_ultimate_version"].includes(v);
      }
    },
    // 弹框要高亮的版本
    activeVersion: {
      type: String,
      default: "enterprise_version",
      validator(v) {
        return ["advance_version", "enterprise_version", "enterprise_ultimate_version"].includes(v);
      }
    },
    // 高亮的权益
    activeEquity: {
      type: String,
      default: ""
    },
    // 弹窗在body节点内的层级
    zIndex: {
      type: Number,
      default: 1000
    },
    // 套餐购买成功后是否需要刷新当前页
    needReload: {
      type: Boolean,
      default: true
    },
    // 弹框来源、入口
    source: {
      type: String,
      default: ""
    },
    // 确认弹窗支付的最高级样式,解决特出场景下继承父类层级关系无法解决弹窗位置的时候单独使用   confirmZindex > zIndex
    confirmZindex: {
      type: Number,
      default: null
    },
    // 微应用调整
    microData: {
      type: Object,
      default: null
    },
    // 最高优先级移除某个版本 这是最先的
    excludes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const appendUrl = "//s1.wenjuan.com/assets/images/business/package-dialog/";
    return {
      appendUrl,
      show: false,
      userInfo: {},
      // 用户信息
      innerActiveVersion: "",
      // 当前高亮的版本
      activeTime: 1,
      // 当前高亮的套餐购买年份
      currentVersion: "free",
      // 当前版本信息
      restIndate: 0,
      // 当前版本剩余有效期，单位(天)
      coupons: [],
      // 选中版本的优惠券列表
      currentSubAccount: 0,
      // 当前版本子账号
      serviceQrcode: "https://s1.wenjuan.com/assets/images/customer-service/support1.png",
      // "https://s1.wenjuan.com/assets/images/customer-service/wx-wsh.png", // 服务顾问,也是对公账号二维码
      serviceNum: "02180394911",
      // 服务顾问电话号码
      accountQrcode: "",
      // 对公转账二维码
      disableUpgrade: false,
      // 当前账号套餐过期时长超过5年，禁止升级
      microAppInfo: {},
      // 微应用账号信息
      isLoading: false,
      // 是否加载完成
      corpId: "",
      // 钉钉用户corp_id
      dialogInfo: {
        isDingTalk: {
          scanQR: "钉钉扫描二维码",
          description: "企业管理员登录钉钉应用中心，进入问卷网页面点击右上角“立即购买”，选择套餐进行购买 ",
          imgTLX: `${appendUrl}TLX-dd.png`,
          imgHA: `${appendUrl}HA-dd.png`,
          iconImg: `${appendUrl}dingTalk.svg`
        },
        isFeishu: {
          scanQR: "飞书扫描二维码",
          description: "企业管理员登录飞书管理后台，进入问卷网，在应用付费处点击“购买付费方案”进行购买 ",
          imgTLX: `${appendUrl}TLX-fs.png`,
          imgHA: `${appendUrl}HA-fs.png`,
          iconImg: `${appendUrl}feiShu.svg`
        },
        isWxwork: {
          scanQR: "微信或企业微信扫描二维码",
          description: "企业管理员登录企业微信管理后台，在第三方应用-问卷网页面点击“进入应用管理”，在应用版本处选择套餐进行购买",
          imgTLX: `${appendUrl}TLX-wx .png`,
          imgHA: `${appendUrl}HA-wx.png`,
          iconImg: `${appendUrl}wxWork.svg`
        }
      },
      jumpButton: {
        isDingTalk: "登录钉钉应用中心",
        isFeishu: "登录飞书管理后台",
        isWxwork: "登录企微管理后台"
      },
      corpIdIndex: "",
      // 根据corpId余数随机销售二维码
      goods_id: "",
      // 选择套餐的goods_id
      isPackageLoading: true // 正在获取套餐信息Loading
    };
  },

  computed: {
    isPkgUpgrad() {
      const versionEnums = Object.keys(MEMBER_PKG_TYPE_MAPPING);
      const currentVersionIndex = versionEnums.findIndex(v => v === this.currentVersion);
      const activeVersionIndex = versionEnums.findIndex(v => v === this.activeVersion);
      return activeVersionIndex > currentVersionIndex;
    },
    isWAUser() {
      console.log(this.microAppInfo.isWAUser);
      return this.microAppInfo.isWAUser;
    },
    versionList() {
      var _this$microAppInfo, _this$microAppInfo2;
      const versionEnums = Object.keys(MEMBER_PKG_TYPE_MAPPING);
      const currentVersionIndex = versionEnums.findIndex(v => v === this.currentVersion);
      const lowestVersionIndex = versionEnums.findIndex(v => v === this.lowestVersion);
      const activeVersionIndex = versionEnums.findIndex(v => v === this.activeVersion);
      let mapList = payVersionList;
      // 升级版本是free🙅‍，或者当前版本是免费版 支持三个选项不支持此操作
      if (activeVersionIndex === 0 || (_this$microAppInfo = this.microAppInfo) !== null && _this$microAppInfo !== void 0 && _this$microAppInfo.isFreeTry) {
        mapList = payVersionList;
      } else if (currentVersionIndex === activeVersionIndex) {
        // 续费（非free） 只有一个结果
        mapList = [payVersionList[activeVersionIndex - 1]];
      } else if (activeVersionIndex > currentVersionIndex) {
        // 升级，有2种情况
        // 默认会把currentVersion（不包含）之后的所有版本都展示
        // 如果lowestVersion大于activeVersionIndex，则只展示lowestVersion（包含）之后的版本
        mapList = payVersionList.filter((v, i) => i > currentVersionIndex - 1 && i >= lowestVersionIndex - 1);
      }
      if (activeVersionIndex < currentVersionIndex && !((_this$microAppInfo2 = this.microAppInfo) !== null && _this$microAppInfo2 !== void 0 && _this$microAppInfo2.isFreeTry)) {
        message_default()({
          message: "不可以购买低于现有套餐版本的套餐，请注意传参",
          type: "warning"
        });
      }
      mapList = mapList.filter(v => !this.excludes.includes(v.key));
      // 反向升级😅或者参数无效
      return mapList;
    },
    // 隐藏中间四位的手机号
    phoneNum() {
      if (this.userInfo.mobile) {
        return `${this.userInfo.mobile.toString().slice(0, 3)}****${this.userInfo.mobile.toString().slice(-4)}`;
      }
      return "";
    },
    dialogVisile: {
      get() {
        return this.visible;
      },
      set() {
        this.$emit("close");
      }
    },
    // 随机分配销售
    randomSale() {
      return ["imgTLX", "imgHA"][this.corpIdIndex];
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        this.innerActiveVersion = payVersionListProxy[this.activeVersion];
        this.activeTime = 1;
        // 仅当弹窗打开时再请求接口，避免组件被挂载后，因为接口获取而出现各种toast
        if (v) {
          this.initBefore();
          // 挂载弹窗到body，提高zindex层级
          this.$nextTick(() => {
            document.body.appendChild(this.$el);
          });
        }
      }
    },
    // 外界传入改变内部
    microData: {
      handler(cval) {
        cval && (this.microAppInfo = cval);
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.addScript();
  },
  methods: {
    // 在弹窗打开时候预先执行的逻辑
    initBefore() {
      this.getUserInfo();
      this.getCouponsAndPackage(true);
      // this.getQrcodeInfo();
      getCorpInfo().then(res => {
        this.corpIdIndex = res.data.corp_id.charCodeAt(res.data.corp_id.length - 1) % 2;
      });
    },
    // 左侧更改套餐版本及购买时长emit
    changeVersion(obj) {
      this.innerActiveVersion = obj.activeVersion;
      this.activeTime = obj.activeTime;
      this.getCouponsAndPackage();
    },
    // 获取用户基本信息
    getUserInfo() {
      getUserInfo().then(res => {
        if (res.status == 200) {
          this.userInfo = res.data || {};
          this.httpMemberPackageInfo();
        }
      }).catch(err => {
        console.log("err", err);
        if (typeof err === "object" && err.data.err_msg) {
          message_default()({
            message: err.data.err_msg,
            type: "warning"
          });
        } else {
          return Promise.reject(err);
        }
      });
    },
    httpDingTalkCorpId() {
      dingTalkCorpId({
        member_id: this.userInfo.id
      }).then(res => {
        if (res.status === 200 && res.status_code === 1) {
          this.corpId = res.data.corp_id;
          window.open(`dingtalk://dingtalkclient/page/link?url=https%3A%2F%2Fh5.dingtalk.com%2Fappcenter%2Findex-pc.html%3Fddtab%3Dtrue%26funnelsource%3D%26source%3D%26corpId%3D${this.corpId}%23%2Fdetail%2FDT_GOODS_881650260477337`, "_blank");
        }
      }).catch(err => {
        console.log(err);
      });
    },
    JumpLink() {
      if (this.isWAUser === "isDingTalk") {
        this.httpDingTalkCorpId();
      } else if (this.isWAUser === "isFeishu") {
        window.open("https://applink.feishu.cn/client/web_url/open?mode=window&url=https%3A%2F%2Fwww.feishu.cn%2Fadmin%2FappCenter%2Fmanage%2Fcli_9c10807b13b01108", "_blank");
      } else if (this.isWAUser === "isWxwork") {
        window.open("https://work.weixin.qq.com/wework_admin/frame#/apps/appStore/detail/MTk3MDMyNTA4MzA0NTk1NF8zNjU1Nl8x/show", "_blank");
      }
    },
    //  获取套餐信息
    httpMemberPackageInfo() {
      Object(package_dialog["a" /* httpMemberPackageInfo */])().then(res => {
        if (res.status === 200 && res.status_code === 1) {
          const {
            data
          } = res;
          console.log(data);
          // 当前套餐是否为试用套餐
          this.getMicroAppInfo(data);
        }
      }).catch(err => {
        console.log(err, "指引弹窗报错提示");
      });
    },
    // 获取优惠券信息及账号套餐信息
    getCouponsAndPackage() {
      let isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      avaliableCoupons(this.innerActiveVersion).then(res => {
        this.isPackageLoading = false;
        this.coupons = res.data;
        // 免费版不存在package字段
        if (res.package) {
          this.currentSubAccount = res.package.sub_account_count;
          this.currentVersion = res.package.version;
          console.log(this.currentVersion, "this.currentVersion");
          this.restIndate = this.dateToDays(res.package.expire_time);

          // 若用户版本套餐时间超过5年，点击升级打开付费套餐弹窗toast
          this.disableUpgrade = this.restIndate > 1825 && this.isPkgUpgrad;
          if (this.disableUpgrade) {
            this.activeTime = 0;
            message_default()({
              message: "当前套餐升级时长不可选，请联系服务顾问",
              type: "warning"
            });
          } else if (this.isPkgUpgrad) {
            // 升级
            if (this.restIndate > 1095) {
              // 用户当前套餐有效期超过3年，但不超过5年，默认选中5年
              this.activeTime = 5;
            } else if (this.restIndate > 365 && isInit) {
              // 用户当前套餐有效期超过1年，但不超过3年，默认选中3年-ID: 1089486（仅初始化执行，切换时间不执行）
              this.activeTime = 3;
            }
          }
        }
      }).catch(err => {
        this.isPackageLoading = false;
        if (typeof err === "object" && err.data.err_msg) {
          message_default()({
            message: err.data.err_msg,
            type: "warning"
          });
        } else {
          return Promise.reject(err);
        }
      });
    },
    // 有效期转换为剩余天数
    dateToDays(expireTime) {
      // 因为到期时间包含当天，所以需要以当天最晚时间来计算
      return Math.ceil((new Date(`${expireTime} 23:59:59`) - new Date().getTime()) / 1000 / 60 / 60 / 24);
    },
    // 返回微应用账号信息
    getMicroAppInfo(data) {
      const curMicroData = {};
      if (data) {
        var _data$package_status, _data$package_status2;
        curMicroData.isFreeTry = data === null || data === void 0 ? void 0 : (_data$package_status = data.package_status) === null || _data$package_status === void 0 ? void 0 : _data$package_status.is_trial;
        curMicroData.isWAUser = data === null || data === void 0 ? void 0 : data.third_part_type;
        curMicroData.version = data === null || data === void 0 ? void 0 : (_data$package_status2 = data.package_status) === null || _data$package_status2 === void 0 ? void 0 : _data$package_status2.version;
      }
      const [isWxwork, isDingTalk, isFeishu] = [tools["default"].$ENV.get("isWxwork"), tools["default"].$ENV.get("isDingTalk"), tools["default"].$ENV.get("isLark")];
      const mapList = {
        isWxwork: "isWxwork",
        isDingTalk: "isDingTalk",
        business_wx: "isWxwork",
        ding_talk: "isDingTalk",
        feishu: "isFeishu",
        isFeishu: "isFeishu",
        default: ""
      };
      // 合并所有数据来源
      Object.assign(curMicroData, {
        isWAUser: mapList[curMicroData.isWAUser] || mapList.default,
        // 微应用账户
        isMicroEnv: isWxwork || isDingTalk || isFeishu,
        // 是不是微应用环境
        isWxwork,
        isDingTalk,
        isFeishu,
        curMicro: isDingTalk ? "isDingTalk" : isFeishu ? "isFeishu" : isWxwork ? "isWxwork" : "Mozilla" // 当前微笑应用环境
      }, this.microData);
      this.microAppInfo = curMicroData;
      //  如果当前版本是试用版， 则高亮对应的正式版版本
      if (this.microAppInfo.isFreeTry && !this.excludes.length) this.innerActiveVersion = this.microAppInfo.version;
      this.isLoading = true;
    },
    // 随机二维码
    ramdonEQcode() {
      // eslint-disable-next-line no-bitwise
    },
    addScript() {
      const actionAppend = () => {
        const {
          serverSize,
          serverName
        } = window.$cndServicer;
        // eslint-disable-next-line no-bitwise
        const index = ~~(Math.random() * serverSize) + 1;
        const name = `${serverName}${index}`;
        this.serviceQrcode = `https://s1.wenjuan.com/assets/images/customer-service/${name}.png`;
        console.log("加载客服插件成功");
      };
      try {
        if (window.$cndServicer) {
          actionAppend();
          return;
        }
        const dom = document.createElement("script");
        // eslint-disable-next-line no-bitwise
        dom.src = `https://s1.wenjuan.com/lib/set-servicer/index.js?t=${~~(Math.random() * 10000)}`;
        dom.onload = actionAppend;
        dom.onerror = e => {
          console.log("加载客服插件失败", e, dom);
        };
        document.body.append(dom);
      } catch (e) {
        console.log("购买弹窗mounted运行失败");
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/package-dialog/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var package_dialog_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/package-dialog/src/index.vue?vue&type=style&index=0&id=401cf2ae&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/package-dialog/src/index.vue?vue&type=style&index=0&id=401cf2ae&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/package-dialog/src/index.vue






/* normalize component */

var src_component = Object(componentNormalizer["a" /* default */])(
  package_dialog_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "401cf2ae",
  null
  
)

/* harmony default export */ var src = (src_component.exports);
// CONCATENATED MODULE: ./packages/package-dialog/index.js

src.install = function (Vue) {
  Vue.component(src.name, src);
};
/* harmony default export */ var packages_package_dialog = __webpack_exports__["default"] = (src);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dialog");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/button.css");

/***/ })

/******/ })["default"];